import { render, staticRenderFns } from "./oversold_list.vue?vue&type=template&id=969abca8&scoped=true"
import script from "./oversold_list.vue?vue&type=script&lang=js"
export * from "./oversold_list.vue?vue&type=script&lang=js"
import style0 from "./oversold_list.vue?vue&type=style&index=0&id=969abca8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "969abca8",
  null
  
)

export default component.exports